import { z } from 'zod';

// FGO Users screen bulk Tag action (task 06): grant or remove one Badge across either a
// bounded, explicit set of member ids (the mail-client "page selection" pattern, capped) or
// the same filter definition the members-search request uses ("select all matching").
// Mirrors the backend's FgoBulkBadgeOperation/FgoBulkBadgeFilterView/FgoBulkBadgeView. This
// schema only constrains what the client sends; the authoritative checks (exactly one of
// userIds/filter, the 100-id cap, badge-belongs-to-fangroup) still live server-side.
export const fanGroupBadgeBulkOperations = ['GRANT', 'REMOVE'] as const;

export type FanGroupBadgeBulkOperation = (typeof fanGroupBadgeBulkOperations)[number];

// Same three fields as CreateFanGroupMemberSegmentValidatorSchema's filter shape -- the "all
// matching" side of the bulk action, evaluated through the identical members-search filter
// semantics.
export const FanGroupBadgeBulkFilterValidatorSchema = z.object({
  locationFilters: z.array(z.string()).optional(),
  badgeIds: z.array(z.string()).optional(),
  query: z.string().optional(),
});

export type FanGroupBadgeBulkFilter = z.infer<
  typeof FanGroupBadgeBulkFilterValidatorSchema
>;

export const FanGroupBadgeBulkValidatorSchema = z.object({
  badgeId: z.string(),
  operation: z.enum(fanGroupBadgeBulkOperations),
  // Exactly one of userIds / filter is required (enforced server-side) -- never both, never
  // neither. Capped at 100 entries server-side (a page's worth of checkbox selections).
  userIds: z.array(z.string()).optional(),
  filter: FanGroupBadgeBulkFilterValidatorSchema.optional(),
});

export type FanGroupBadgeBulkValidator = z.infer<
  typeof FanGroupBadgeBulkValidatorSchema
>;
